import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { BrandingProvider } from "./context/BrandingContext";
import PrivateRoute from "./components/PrivateRoute";

// Auth pages
import Login from "./pages/auth/Login";
import AdminLogin from "./pages/auth/AdminLogin";

// Super Admin pages
import SuperAdminDashboard from "./pages/superadmin/SuperAdminDashboard";

// Admin pages
import AdminDashboard from "./pages/admin/AdminDashboard";

// Supervisor pages
import SupervisorDashboard from "./pages/supervisor/SupervisorDashboard";

// Operator pages
import OperatorDashboard from "./pages/operator/OperatorDashboard";

// Vendor pages
import VendorDashboard from "./pages/vendor/VendorDashboard";

function App() {
  return (
    <BrowserRouter>
      <BrandingProvider>
      <AuthProvider>
        <LanguageProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />

            {/* Admin login via super admin impersonation */}
            <Route path="/admin-login" element={<AdminLogin />} />

            {/* Super Admin routes */}
            <Route path="/superadmin/*" element={
              <PrivateRoute allowedRoles={["super_admin"]}>
                <SuperAdminDashboard />
              </PrivateRoute>
            } />

            {/* Admin routes */}
            <Route path="/admin/*" element={
              <PrivateRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </PrivateRoute>
            } />

            {/* Supervisor routes */}
            <Route path="/supervisor/*" element={
              <PrivateRoute allowedRoles={["supervisor"]}>
                <SupervisorDashboard />
              </PrivateRoute>
            } />

            {/* Operator routes */}
            <Route path="/operator/*" element={
              <PrivateRoute allowedRoles={["operator"]}>
                <OperatorDashboard />
              </PrivateRoute>
            } />

            {/* Vendor routes */}
            <Route path="/vendor/*" element={
              <PrivateRoute allowedRoles={["vendor"]}>
                <VendorDashboard />
              </PrivateRoute>
            } />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </LanguageProvider>
      </AuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  );
}

export default App;
